import { render, staticRenderFns } from "./AgeConfirmation.vue?vue&type=template&id=1ff6af84&scoped=true&"
import script from "./AgeConfirmation.vue?vue&type=script&lang=js&"
export * from "./AgeConfirmation.vue?vue&type=script&lang=js&"
import style0 from "./AgeConfirmation.vue?vue&type=style&index=0&id=1ff6af84&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1ff6af84",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VApp } from 'vuetify/lib/components/VApp';
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VCard } from 'vuetify/lib/components/VCard';
import { VCardActions } from 'vuetify/lib/components/VCard';
import { VCardTitle } from 'vuetify/lib/components/VCard';
import { VDialog } from 'vuetify/lib/components/VDialog';
import { VDivider } from 'vuetify/lib/components/VDivider';
import { VSpacer } from 'vuetify/lib/components/VGrid';
installComponents(component, {VApp,VBtn,VCard,VCardActions,VCardTitle,VDialog,VDivider,VSpacer})
